import cn from 'classnames';
import styles from './CopyrightsText.module.sass';
interface CopyrightTextProps extends React.HTMLAttributes<HTMLDivElement> {
    text: string;
    border?: boolean;
}

export const CopyrightText = ({ text, border = false, ...props }: CopyrightTextProps) => {
    if (!text) {
        return null;
    }

    return (
        <div className={cn(styles.copyright, { [styles.border]: border })} {...props}>
            <span dangerouslySetInnerHTML={{ __html: text }}></span>
        </div>
    );
};
